<template>
  <div class="nx-list-page dynamic-inventory-page">
    <div class="dynamic-inventory-page__above">
      <div class="metric-grid">
        <div v-for="item in metrics" :key="item.label" class="metric-card" :class="item.className">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
          <em>{{ item.extra }}</em>
        </div>
      </div>
    </div>

    <div class="inventory-panel">
      <div class="inventory-panel__header">
        <el-tabs v-model="activeTab" class="inventory-tabs" @tab-click="handleTabChange">
          <el-tab-pane label="库存明细" name="detail" />
          <el-tab-pane label="按客户合并" name="customer" />
          <el-tab-pane label="按煤种合并" name="cargo" />
          <el-tab-pane label="按煤棚合并" name="store" />
        </el-tabs>
      </div>

      <div class="inventory-panel__body">
        <avue-crud
          ref="crud"
          v-model="form"
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :search.sync="query"
          :defaults.sync="defaults"
          @search-change="searchChange"
          @search-reset="searchReset"
          @refresh-change="refreshChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
        >
          <template slot="menuLeft">
            <el-button size="small" type="primary" plain icon="el-icon-download" :loading="exportLoading" @click="exportCurrent">导出</el-button>
            <el-button size="small" type="warning" @click="showWarningOnly">预警筛选</el-button>
          </template>

          <template slot="stockAmount" slot-scope="{ row }">
            {{ formatNumber(row.stockAmount) }}
          </template>
          <template slot="capacityAmount" slot-scope="{ row }">
            {{ formatNumber(row.capacityAmount) }}
          </template>
          <template slot="capacityRate" slot-scope="{ row }">
            <div class="capacity-cell">
              <el-progress :percentage="toPercent(row.capacityRate)" :show-text="false" :stroke-width="8" />
              <span>{{ toPercent(row.capacityRate) }}%</span>
            </div>
          </template>
          <template slot="stockStatusText" slot-scope="{ row }">
            <el-tag :type="statusType(row.stockStatus)" size="small">{{ row.stockStatusText || "正常" }}</el-tag>
          </template>
          <template slot="menu" slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
          </template>
        </avue-crud>
      </div>
    </div>

    <el-dialog
      title="库存详情"
      :visible.sync="detailVisible"
      width="520px"
      append-to-body
      modal-append-to-body
      :close-on-click-modal="true"
      destroy-on-close
    >
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="客户">{{ currentRow.custName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="煤种">{{ currentRow.varName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="煤棚">{{ currentRow.storeName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="堆位">{{ currentRow.locationName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="库存量">{{ formatNumber(currentRow.stockAmount) }} 吨</el-descriptions-item>
        <el-descriptions-item label="容量">{{ formatNumber(currentRow.capacityAmount) }} 吨</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getDetailPage, getGroupPage, getStatistics } from "./api";
import { export_json_to_excel } from "@/util/vendor/Export2Excel";

export default {
  name: "DynamicInventoryManagement",
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {},
      exportLoading: false,
      activeTab: "detail",
      stats: {},
      detailVisible: false,
      currentRow: {},
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        searchLabelWidth: 112,
        searchMenuSpanSuper: 6,
        menu: {
          width: 90,
          fixed: "right",
          align: "center",
        },
        column: [
          {
            label: "客户",
            prop: "custNo",
            type: "select",
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            props: {
              label: "deptName",
              value: "id",
            },
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "煤棚",
            prop: "storeNo",
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "堆位",
            prop: "locationCode",
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "煤种",
            prop: "varNo",
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "库存最小(吨)",
            prop: "stockMin",
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "库存最大(吨)",
            prop: "stockMax",
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "库存状态",
            prop: "stockStatus",
            type: "select",
            search: true,
            searchSpan: 6,
            hide: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            dicData: [
              { label: "空仓", value: 0 },
              { label: "正常", value: 1 },
              { label: "高位", value: 2 },
            ],
          },
          {
            label: "客户名称",
            prop: "custName",
            minWidth: 150,
            overHidden: true,
          },
          {
            label: "煤棚",
            prop: "storeName",
            minWidth: 130,
            overHidden: true,
          },
          {
            label: "堆位",
            prop: "locationName",
            minWidth: 120,
            overHidden: true,
          },
          {
            label: "煤种",
            prop: "varName",
            minWidth: 130,
            overHidden: true,
          },
          {
            label: "当前库存量(吨)",
            prop: "stockAmount",
            minWidth: 140,
            align: "right",
            slot: true,
          },
          {
            label: "容量(吨)",
            prop: "capacityAmount",
            minWidth: 120,
            align: "right",
            slot: true,
          },
          {
            label: "容量占比",
            prop: "capacityRate",
            minWidth: 150,
            slot: true,
          },
          {
            label: "库存状态",
            prop: "stockStatusText",
            minWidth: 100,
            slot: true,
          },
          {
            label: "更新时间",
            prop: "updateTime",
            minWidth: 160,
            overHidden: true,
          },
        ],
      },
    };
  },
  computed: {
    metrics() {
      return [
        { label: "库存总量", value: this.formatNumber(this.stats.totalStockAmount), extra: "实时堆位库存", className: "metric-card--primary" },
        { label: "总容量", value: this.formatNumber(this.stats.totalCapacityAmount), extra: "容量上限/设计容量", className: "metric-card--success" },
        { label: "可用容量", value: this.formatNumber(this.stats.totalAvailableAmount), extra: "容量 - 库存", className: "metric-card--warning" },
        { label: "堆位数量", value: this.stats.stackCount || 0, extra: "有效堆位", className: "" },
        { label: "高位预警", value: this.stats.warningCount || 0, extra: "容量占比>=90%", className: "metric-card--danger" },
        { label: "空仓堆位", value: this.stats.emptyCount || 0, extra: "库存量<=0", className: "" },
      ];
    },
  },
  created() {
    this.apiConfig = {
      getList: (params) => this.getInventoryList(params),
    };
    this.syncTabColumns();
  },
  methods: {
    getInventoryList(params) {
      return this.activeTab === "detail"
        ? getDetailPage(params)
        : getGroupPage(this.activeTab, params);
    },
    initCardData() {
      getStatistics(this.queryData).then((res) => {
        this.stats = res.data.data || {};
      });
    },
    formatParams(params) {
      const result = crudMixins.methods.formatParams.call(this, params);
      Object.keys(result).forEach((key) => {
        if (result[key] === "") delete result[key];
      });
      return result;
    },
    syncTabColumns() {
      const locationColumn = this.option.column.find((item) => item.prop === "locationName");
      if (locationColumn) {
        this.$set(locationColumn, "hide", this.activeTab !== "detail");
      }
    },
    handleTabChange() {
      this.syncTabColumns();
      this.page.currentPage = 1;
      this.selectionClear();
      this.onLoad(this.page, this.query);
      this.$nextTick(() => {
        this.$refs.crud && this.$refs.crud.doLayout && this.$refs.crud.doLayout();
      });
    },
    showWarningOnly() {
      this.$set(this.query, "stockStatus", 2);
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
    },
    openDetail(row) {
      this.currentRow = row || {};
      this.detailVisible = true;
    },
    exportCurrent() {
      const rows = this.responseData || this.data || [];
      if (!rows.length) {
        this.$message.warning("无数据可导出");
        return;
      }
      this.exportLoading = true;
      try {
        const columns = this.getExportColumns();
        const header = columns.map((item) => item.label);
        const data = rows.map((row) => columns.map((item) => item.formatter ? item.formatter(row) : row[item.prop]));
        export_json_to_excel(header, data, `动态库存_${Date.now()}`);
        this.$message.success("导出成功");
      } finally {
        this.exportLoading = false;
      }
    },
    getExportColumns() {
      const columns = [
        { label: "客户名称", prop: "custName" },
        { label: "煤棚", prop: "storeName" },
      ];
      if (this.activeTab === "detail") {
        columns.push({ label: "堆位", prop: "locationName" });
      }
      return columns.concat([
        { label: "煤种", prop: "varName" },
        { label: "当前库存量(吨)", prop: "stockAmount", formatter: (row) => this.formatNumber(row.stockAmount) },
        { label: "容量(吨)", prop: "capacityAmount", formatter: (row) => this.formatNumber(row.capacityAmount) },
        { label: "容量占比", prop: "capacityRate", formatter: (row) => `${this.toPercent(row.capacityRate)}%` },
        { label: "库存状态", prop: "stockStatusText", formatter: (row) => row.stockStatusText || "正常" },
        { label: "更新时间", prop: "updateTime" },
      ]);
    },
    toPercent(value) {
      const num = Number(value || 0);
      if (num < 0) return 0;
      if (num > 100) return 100;
      return Number(num.toFixed(2));
    },
    statusType(status) {
      if (status === 0) return "info";
      if (status === 2) return "danger";
      return "success";
    },
    formatNumber(value) {
      const num = Number(value || 0);
      return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style scoped lang="scss">
.dynamic-inventory-page {
  .dynamic-inventory-page__above {
    margin-bottom: 12px;
  }

  .metric-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(140px, 1fr));
    gap: 10px;
    margin-bottom: 12px;
  }

  .metric-card {
    min-height: 86px;
    padding: 14px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;

    span {
      display: block;
      margin-bottom: 10px;
      color: #64748b;
      font-size: 13px;
    }

    strong {
      display: block;
      color: #111827;
      font-size: 24px;
      line-height: 28px;
      font-weight: 700;
    }

    em {
      display: block;
      margin-top: 6px;
      color: #94a3b8;
      font-style: normal;
      font-size: 12px;
    }

    &--primary strong {
      color: #2563eb;
    }

    &--success strong {
      color: #15803d;
    }

    &--warning strong {
      color: #b45309;
    }

    &--danger strong {
      color: #dc2626;
    }
  }

  .inventory-panel {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
  }

  .inventory-panel__header {
    display: flex;
    align-items: center;
    min-height: 46px;
    padding: 0 18px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
  }

  .inventory-panel__body {
    background: #fff;
  }

  .inventory-tabs {
    width: 100%;
  }

  .capacity-cell {
    display: grid;
    grid-template-columns: 1fr 46px;
    align-items: center;
    gap: 8px;
  }
}

::v-deep .inventory-tabs .el-tabs__header {
  margin: 0;
}

::v-deep .inventory-tabs .el-tabs__item {
  height: 46px;
  line-height: 46px;
}

::v-deep .inventory-tabs .el-tabs__nav-wrap::after {
  height: 0;
}

::v-deep .inventory-panel .avue-crud {
  padding: 0;
}

::v-deep .inventory-panel .avue-crud__search {
  margin: 0;
  padding: 0;
  background: #fff;
}

::v-deep .inventory-panel .avue-crud__search > .el-card__body {
  padding: 12px 16px 10px !important;
  box-sizing: border-box;
}

::v-deep .inventory-panel .avue-crud__search .avue-group--header {
  padding: 10px 5px 3px;
  background: #f0f7ff;
  box-sizing: border-box;
}

::v-deep .inventory-panel .avue-crud__menu {
  margin: 0;
  box-sizing: border-box;
}

::v-deep .inventory-panel .avue-crud__table {
  padding: 0 16px;
}

::v-deep .inventory-panel .avue-crud__pagination {
  margin: 0;
  padding: 8px 16px;
  border-top: 1px solid #ebeef5;
  box-sizing: border-box;
}

@media (max-width: 1400px) {
  .dynamic-inventory-page {
    .metric-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .dynamic-inventory-page {
    .metric-grid {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .inventory-panel__header {
      align-items: stretch;
      flex-direction: column;
      padding: 8px 16px;
    }

  }
}
</style>
